import { initialState } from "./state"
import { mutations } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  setIsEditing: (state, payload) => (state.isEditing = payload),
  setCoverageToEditId: (state, payload) => (state.coverageToEditId = payload),
  setAreas: (state, payload) => (state.areas = payload),
  resetState: state => Object.assign(state, initialState),
  ...mutations
}
